// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2kHJo","amount":"Amount_amount__uW1LP","tip":"Amount_tip__22jjn","tipHeader":"Amount_tipHeader__TvFja","tipsWrap":"Amount_tipsWrap__2BvDF"};